class MinerwaConsultation extends HTMLElement {
  connectedCallback() {
    this.toggle = this.querySelector('[data-consult-toggle]');
    this.panel = this.querySelector('#minerwa-consult-panel');
    this.tooltip = this.querySelector('[data-tooltip]');
    if (!this.toggle || !this.panel) return;

    this.onKeyDown = this.onKeyDown.bind(this);
    this.onDocumentClick = this.onDocumentClick.bind(this);

    this.toggle.addEventListener('click', () => {
      this.panel.hidden ? this.open() : this.close();
    });

    this.querySelector('[data-tooltip-close]')?.addEventListener('click', (event) => {
      event.stopPropagation();
      this.hideTooltip();
    });

    const seconds = Number(this.dataset.tooltipTimeout) || 0;
    if (seconds > 0) {
      this.tooltipTimer = setTimeout(() => this.hideTooltip(), seconds * 1000);
    }
  }

  disconnectedCallback() {
    clearTimeout(this.tooltipTimer);
    document.removeEventListener('keydown', this.onKeyDown);
    document.removeEventListener('mousedown', this.onDocumentClick);
  }

  hideTooltip() {
    if (this.tooltip) this.tooltip.hidden = true;
  }

  open() {
    this.panel.hidden = false;
    this.toggle.setAttribute('aria-expanded', 'true');
    this.hideTooltip();
    document.addEventListener('keydown', this.onKeyDown);
    document.addEventListener('mousedown', this.onDocumentClick);
  }

  close() {
    this.panel.hidden = true;
    this.toggle.setAttribute('aria-expanded', 'false');
    document.removeEventListener('keydown', this.onKeyDown);
    document.removeEventListener('mousedown', this.onDocumentClick);
  }

  onKeyDown(event) {
    if (event.key === 'Escape') {
      this.close();
      this.toggle.focus();
    }
  }

  onDocumentClick(event) {
    if (!this.contains(event.target)) this.close();
  }
}

if (!customElements.get('minerwa-consultation')) {
  customElements.define('minerwa-consultation', MinerwaConsultation);
}
